export default __webpack_public_path__ + "static/media/60.d0feec1c.png";